import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../../base.graphql";

export const CREATE_CITIZEN_MUTATION = gql`
  mutation CreateCitizenMutation($input: CitizenProfileInputObject) {
    createCitizenMutation(input: $input) {
      ${baseResponseGraphqlField}
    }
  }`
